import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedApi } from '../api';
import { useAuth0 } from '@auth0/auth0-react';

const fetchBlogPosts = async (authenticatedFetch, limit = 20, offset = 0) => {
  const response = await authenticatedFetch(`${process.env.REACT_APP_API_URL || '/api'}/wordpress/posts?limit=${limit}&offset=${offset}`);
  
  if (!response.ok) {
    throw new Error('Failed to fetch blog posts');
  }
  
  return response.json();
};

export const useBlogPosts = (limit = 20, offset = 0) => {
  const { authenticatedFetch } = useAuthenticatedApi();
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  
  return useQuery({
    queryKey: ['blogPosts', limit, offset],
    queryFn: () => fetchBlogPosts(authenticatedFetch, limit, offset),
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
    retryDelay: 1000,
    refetchOnMount: true,
    enabled: !authLoading && isAuthenticated && !!authenticatedFetch,
  });
};
